import { c as _c } from "react/compiler-runtime";
import { ArrowRight } from "lucide-react";
import { Typography } from "@repo/ui/aops-components/typography";
import type { CoursePageSection, FullCourseLevel, FullCourseOffering, FullCourseOfferings } from "@repo/sanity-utils/query-types";
import { sendDiscoveryEventBeacon } from "@/lib/discoveryEventBeacon";
import { getSecondaryCTAHeader, getSecondaryCTAScheduleLinks, resolveScheduleLinkTrackingEvent } from "./SecondaryCTAUtils";
import styles from "./SecondaryCTA.module.css";
interface SecondaryCTAProps {
  courseOfferings: FullCourseOfferings;
  offering: FullCourseOffering;
  courseSlug: string;
  campusIdForUrl: string | null;
  selectedCampusId: string | null;
  consultationUrl: string;
  hasPlacementTest: boolean;
  placementTestUrl: string;
  showBookConsultationButtons: boolean;
  coursePageSection?: NonNullable<CoursePageSection>;
  sequenceType?: NonNullable<FullCourseLevel>["sequenceType"];
}

/**
 * This is the bottom section of the CTA Card
 */
export function SecondaryCTA(t0) {
  const $ = _c(12);
  const {
    courseOfferings,
    offering,
    courseSlug,
    campusIdForUrl,
    selectedCampusId,
    consultationUrl,
    hasPlacementTest,
    placementTestUrl,
    showBookConsultationButtons,
    coursePageSection,
    sequenceType
  } = t0;
  let t1;
  if ($[0] !== campusIdForUrl || $[1] !== consultationUrl || $[2] !== courseOfferings || $[3] !== coursePageSection?.keyedCopy || $[4] !== courseSlug || $[5] !== hasPlacementTest || $[6] !== offering || $[7] !== placementTestUrl || $[8] !== selectedCampusId || $[9] !== sequenceType || $[10] !== showBookConsultationButtons) {
    const scheduleLinks = getSecondaryCTAScheduleLinks({
      courseOfferings,
      offering,
      campusIdForUrl,
      selectedCampusId,
      consultationUrl,
      hasPlacementTest,
      placementTestUrl,
      showBookConsultationButtons,
      keyedCopy: coursePageSection?.keyedCopy ?? [],
      sequenceType
    });
    const header = getSecondaryCTAHeader(scheduleLinks, coursePageSection?.keyedCopy ?? []);
    t1 = scheduleLinks.length > 0 && <div className={styles.secondaryCTA}><Typography as="p" variant="h5" className={styles.prompt}>{header}</Typography><div className={styles.buttons}>{scheduleLinks.map(t2 => {
          const {
            href,
            label,
            slug
          } = t2;
          return <a key={slug} id={`view-schedule-${slug}-button`} href={href} className={styles.button} target="_blank" rel="noopener noreferrer" aria-disabled={!href} onClick={() => {
            if (!href) {
              return;
            }
            const trackingEvent = resolveScheduleLinkTrackingEvent(slug, courseSlug);
            if (trackingEvent) {
              sendDiscoveryEventBeacon(trackingEvent.event, trackingEvent.properties);
            }
          }}><Typography variant="buttonMd" as="span">{label}</Typography><span className={styles.buttonSpacer} aria-hidden={true} /><ArrowRight aria-hidden={true} size={20} strokeWidth={2.5} /></a>;
        })}</div></div> || null;
    $[0] = campusIdForUrl;
    $[1] = consultationUrl;
    $[2] = courseOfferings;
    $[3] = coursePageSection?.keyedCopy;
    $[4] = courseSlug;
    $[5] = hasPlacementTest;
    $[6] = offering;
    $[7] = placementTestUrl;
    $[8] = selectedCampusId;
    $[9] = sequenceType;
    $[10] = showBookConsultationButtons;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  return t1;
}